<!-- <div class="overlay"> -->
<div class="popup">
    <!-- Header -->
    <div class="popup-header">
        <span>Note Template</span>
        <span class="close" (click)="close()">×</span>
    </div>

    <!-- Content -->
    <div class="content-wrapper">
        <!-- Left Panel: Call Overview & Claim Status -->
        <div class="left-panel">
            <div class="left-panel-inner">
                <div class="panel-header">
                    <h3>Call Overview & {{ caseNoteData.Title }}</h3>
                </div>
                <!-- Breadcrumbs -->
                <div class="breadcrumbs">
                    <span class="breadcrumb-item" *ngIf="Subject" [title]="'Subject: ' + Subject">
                        Subject: {{ Subject.length > 18 ? (Subject | slice:0:18) + '...' : Subject }}
                    </span>
                    <span class="breadcrumb-separator" *ngIf="Subject && Category">></span>
                    <span class="breadcrumb-item" *ngIf="Category" [title]="'Category: ' + Category">
                        Category: {{ Category.length > 18 ? (Category | slice:0:18) + '...' : Category }}
                    </span>
                    <span class="breadcrumb-separator" *ngIf="Category && Issue">></span>
                    <span class="breadcrumb-item" *ngIf="Issue" [title]="'Issue: ' + Issue">
                        Issue: {{ Issue.length > 18 ? (Issue | slice:0:18) + '...' : Issue }}
                    </span>
                </div>

                <div class="call-summary-section">
                    <div *ngFor="let item of SummaryHeader | keyvalue" >
                        <div class="row" *ngIf="transcriptData[item.key]">
                            <div class="input-data">
                                <div class="form-group">
                                    <label for="call-summary">{{item.value}}</label> 
                                    <p class="call-summary"   
                                    [innerHTML]="transcriptData[item.key]"></p>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div *ngIf="!transcriptData || !transcriptData.CallSummary">No Summary Available</div>
                </div>

                <!-- Text Area -->
                <div class="text-area-container">
                    <textarea #overviewTextarea class="overview-textarea"
                        rows="20" [(ngModel)]="caseNoteData.Content"></textarea>
                </div>

                <!-- Button Group -->
                <div class="button-group">
                    <button class="cancel-btn" type="button" (click)="close()">Cancel</button>
                    <button class="save-btn" type="button" (click)="copyNotes($event)">
                        📋 {{ copied ? 'Copied' : 'Copy to Notes' }}
                    </button>
                </div>
            </div>



        </div>

        <!-- Right Panel: Call Transcripts -->
        <div class="right-panel">
            <div class="transcript-wrapper">
                <div class="panel-header">
                    <h3>Call Transcripts</h3>
                    <span class="powered-by">✨ Powered by AI</span>
                </div>

                <div class="chat-container">
                    <!-- Agent Message -->
                    <!-- <div class="message agent-message">
                        <div class="message-header"><span class="text-bold">Agent</span> 08/20/2024, 05:12:45 PM</div>
                        <div class="message-bubble agent-bubble">
                            Good afternoon! Thank you for calling XXX Insurance. My name is Smith. How can I assist you
                            today?
                        </div>
                    </div> -->

                    <!-- Customer Message -->
                    <!-- <div class="message customer-message">
                        <div class="message-header"><span class="text-bold">Antonio</span> 08/20/2024, 05:12:45 PM</div>
                        <div class="message-bubble customer-bubble">
                            Hi Smith, I'm calling about a claim I submitted last month. It was denied, but I believe
                            there's been a misunderstanding. I'd like to request a reconsideration.
                        </div>
                    </div> -->

                    <!-- Agent Message -->
                    <!-- <div class="message agent-message">
                        <div class="message-header"><span class="text-bold">Agent</span> 08/23/2024, 05:12:46 PM</div>
                        <div class="message-bubble agent-bubble">
                            I'm sorry to hear that your claim was denied. I'll do my best to help. May I have your claim
                            number, please?
                        </div>
                    </div> -->

                    <!-- Customer Message -->
                    <!-- <div class="message customer-message">
                        <div class="message-header"><span class="text-bold">Antonio</span> 08/20/2024, 05:12:53 PM</div>
                        <div class="message-bubble customer-bubble">
                            Sure, it's HINS-908754321.
                        </div>
                    </div> -->

                    <!-- Agent Message -->
                    <!-- <div class="message agent-message">
                        <div class="message-header"><span class="text-bold">Agent</span> 08/20/2024, 05:12:46 PM</div>
                        <div class="message-bubble agent-bubble">
                            I'm sorry to hear that your claim was denied. I'll do my best to help. May I have your claim
                            number, please?
                        </div>
                    </div> -->

                    <!-- Customer Message -->
                    <!-- <div class="message customer-message">
                        <div class="message-header"><span class="text-bold">Antonio</span> 08/20/2024, 05:12:53 PM</div>
                        <div class="message-bubble customer-bubble">
                            Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt
                        </div>
                    </div> -->

                    <div *ngFor="let sentence of transcriptData?.Sentences; trackBy: trackByIndex">
                        <div class="message agent-message" *ngIf="sentence?.SpeakerRole?.startsWith('Agent')">
                            <div class="message-header">
                                <span class="text-bold">{{ sentence?.SpeakerRole }}</span> {{ sentence?.formattedTime }}
                            </div>
                            <div class="message-bubble agent-bubble">
                                {{ sentence?.Transcript }}
                            </div>
                        </div>

                        <div class="message customer-message" *ngIf="sentence?.SpeakerRole?.startsWith('Customer')">
                            <div class="message-header">
                                <span class="text-bold">{{ sentence?.SpeakerRole }}</span> {{ sentence?.formattedTime }}
                            </div>
                            <div class="message-bubble customer-bubble">
                                {{ sentence?.Transcript }}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>